import React, { Component } from "react";
import { connect } from "react-redux";
import { Table, Spin, Empty, Layout, Button, Select, Input, Typography, Tag, Dropdown, Menu, Tabs, Row, Col } from "antd";
import { RiSearchLine, RiPrinterLine, RiArrowDownSLine, RiFileCopyLine } from "react-icons/ri";
import { getShipments, getFocusedShipment, updateFulfiller, getPickslips, getManifest, getAllPickslips, searchShipments, getRecentFulfilledShipments, getRecentManifests } from "../../actions/ShippingActionsNew";
import ShippingDropDownComponentPrototype from "./ShippingDropDownComponentPrototype";
import FulfilledShipmentDetails from "./components/FulfilledShipmentDetails";
import OpenShipmentsTable from "./components/OpenShipmentsTable";
import FulfilledShipmentsTable from "./components/FulfilledShipmentsTable";
import ManifestsTable from "./components/ManifestsTable";
import "./components/shippingaccordion.css";
import CollectionTimer from "./components/Timer";
import { Storage } from "aws-amplify/lib";

// Shipment Constants
import METHODS from "../../constants/shipping/MethodTypesNew";
import METHOD from "../../constants/shipping/MethodTypesNew";
import STATUS from "../../constants/shipping/StatusTypesNew";
import CARRIER from "../../constants/shipping/CarrierTypesNew";

// Carrier Logos
import AramexLogo from "../../components/icons/carriers/aramex";
import AuspostLogo from "../../components/icons/carriers/auspost";
import SherpaLogo from "../../components/icons/carriers/sherpa";
import ClickCollectIcon from "../../components/icons/carriers/clickcollect";

// Store Logos
import UniversalStoreStackedLogo from "../../components/icons/stores/universal-store-stacked";
import PerfectStrangerStackedLogo from "../../components/icons/stores/perfect-stranger-stacked";

// Icons
import PendingIcon from "../../images/pending-icon.svg";
import CompletedIcon from "../../images/completed-icon.svg";

var fileDownload = require('js-file-download');

const { Header, Content } = Layout;
const { Title } = Typography;
const { Option } = Select;
const { TabPane } = Tabs;

const mapStateToProps = state => ({
    user: state.authState,
    shipments: state.shippingState.shipments,
    fulfilledShipments: state.shippingState.fulfilledShipments,
    searchedShipments: state.shippingState.searchedShipments,
    manifests: state.shippingState.manifests,
    focusedShipment: state.shippingState.focusedShipment,
    manifest: state.shippingState.manifest,
    isLoadingOpen: state.shippingState.isLoadingOpen,
    isLoadingFulfilled: state.shippingState.isLoadingFulfilled,
    isLoadingManifests: state.shippingState.isLoadingManifests
});

const mapDispatchToProps = dispatch => ({
    getShipments: () => dispatch(getShipments()),
    updateFulfiller: (fulfiller) => dispatch(updateFulfiller(fulfiller)),
    getFocusedShipment: (shipment) => dispatch(getFocusedShipment(shipment)),
    getPickslips: (shipmentId) => dispatch(getPickslips(shipmentId)),
    getManifest: () => dispatch(getManifest()),
    getAllPickslips: (store, type, web_store) => dispatch(getAllPickslips(store, type, web_store)),
    searchShipments: (text, fulfilled) => dispatch(searchShipments(text, fulfilled)),
    getRecentFulfilledShipments: () => dispatch(getRecentFulfilledShipments()),
    getRecentManifests: () => dispatch(getRecentManifests())
});

class ShippingTablePrototype extends Component {
    constructor(props) {
        super(props);
        
        // Get initial tab from URL hash or default to 'open'
        const initialTab = this.getTabFromHash() || 'open';
        
        this.state = {
            shipmentAlerts: [],
            expandedRowKeys: [],
            manifestLoading: false,
            activeTab: initialTab,
            searchText: ''
        };

        this.handleLabelDownload = this.handleLabelDownload.bind(this);
        this.buildShipmentInformation = this.buildShipmentInformation.bind(this);
        this.handleGenerateManifest = this.handleGenerateManifest.bind(this);
        this.handlePickslipGeneration = this.handlePickslipGeneration.bind(this);
        this.handleTabChange = this.handleTabChange.bind(this);
        this.handlePopState = this.handlePopState.bind(this);
        this.handleSearchChange = this.handleSearchChange.bind(this);
    }

    getTabFromHash() {
        const hash = window.location.hash.replace('#', '');
        const validTabs = ['open', 'fulfilled', 'manifests'];
        return validTabs.includes(hash) ? hash : null;
    }

    handlePopState = () => {
        const tabFromHash = this.getTabFromHash();
        if (tabFromHash && tabFromHash !== this.state.activeTab) {
            this.setState({ activeTab: tabFromHash });
            this.loadDataForTab(tabFromHash);
        }
    }

    loadDataForTab(tab) {
        if (tab === 'open') {
            this.props.getShipments();
        } else if (tab === 'fulfilled') {
            this.props.getRecentFulfilledShipments();
        } else if (tab === 'manifests') {
            this.props.getRecentManifests();
        }
    }

    componentDidMount() {
        window.addEventListener('popstate', this.handlePopState);

        // Load data for the current active tab
        this.loadDataForTab(this.state.activeTab);
    }

    componentWillUnmount() {
        window.removeEventListener('popstate', this.handlePopState);
    }

    componentDidUpdate(prevProps) {
        // Open manifest in new tab when it becomes available
        if (this.state.manifestLoading && prevProps.manifest !== this.props.manifest && this.props.manifest && this.props.manifest !== 'disabled') {
            window.open(this.props.manifest, '_blank');
            this.setState({ manifestLoading: false });
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        return (
            this.props.shipments !== nextProps.shipments ||
            this.props.fulfilledShipments !== nextProps.fulfilledShipments ||
            this.props.focusedShipment !== nextProps.focusedShipment ||
            this.props.searchedShipments !== nextProps.searchedShipments ||
            this.props.isLoadingOpen !== nextProps.isLoadingOpen ||
            this.props.isLoadingFulfilled !== nextProps.isLoadingFulfilled ||
            this.props.isLoadingManifests !== nextProps.isLoadingManifests ||
            this.state.shipmentAlerts !== nextState.shipmentAlerts ||
            this.state.expandedRowKeys !== nextState.expandedRowKeys ||
            this.state.searchText !== nextState.searchText ||
            this.state.activeTab !== nextState.activeTab ||
            this.state.manifestLoading !== nextState.manifestLoading
        );
    }

    async handleLabelDownload(name) {
        try {
            const result = await Storage.get('labels/' + name + '-label.pdf', { download: true });
            fileDownload(result.Body, name + '-label.pdf');
        } catch (err) {
            console.error('Error downloading label:', err);
        }
    }

    handleTimerAlert = async (shipmentId, alert) => {
        let index = this.state.shipmentAlerts.findIndex(x => x.id === shipmentId);
        if (index === -1) {
            let joined = this.state.shipmentAlerts.concat({ id: shipmentId, alert: alert });
            this.setState({ shipmentAlerts: joined });
        }
    };

    isDisabled(status) {
        let disabledStatus = [
            STATUS.COMPLETE,
            STATUS.REJECTED,
            STATUS.HOLD,
            STATUS.HOLD_WEIGHT,
            STATUS.FULFILLED
        ];
        return disabledStatus.includes(status);
    }

    renderCarrierLogo(shipment) {
        let carrier = shipment.carrier;
        switch (carrier) {
            case 'AUSPOST':
                return <AuspostLogo />;
            case 'ARAMEX':
                return <AramexLogo />;
            case 'SHERPA':
                return <SherpaLogo />;
            case 'CLICKCOLLECT':
                return <ClickCollectIcon />;
            default:
                return 'Unknown Carrier';
        }
    }

    determineCarrierUrgency(carrier, shipping_method) {
        switch (carrier) {
            case 'SHERPA':
            case 'CLICKCOLLECT':
                return 'urgent';
            case 'AUSPOST':
                return shipping_method === METHODS.EXPRESS ? 'urgent' : '';
            case 'ARAMEX':
                return shipping_method === METHODS.EXPRESS ? 'urgent' : '';
            default:
                return '';
        }
    }

    determineCarrierTitle(shipment) {
        const { carrier, method } = shipment;

        if (method === METHODS.CLICKCOLLECT || carrier === CARRIER.CLICKCOLLECT) {
            return 'Click And Collect';
        }

        switch (carrier) {
            case CARRIER.ARAMEX:
                return 'Aramex Shipping';
            case CARRIER.AUSPOST:
                return method === METHODS.EXPRESS ? 'Auspost Express Shipping' : 'Auspost Standard Shipping';
            case CARRIER.SHERPA:
                return 'Same Day Shipping';
            default:
                return 'Unknown Shipping Method';
        }
    }

    renderStoreLogo(brand) {
        switch (brand) {
            case 'US':
                return <UniversalStoreStackedLogo style={{ height: '32px' }} />;
            case 'PS':
                return <PerfectStrangerStackedLogo style={{ height: '32px' }} />;
            default:
                return <UniversalStoreStackedLogo style={{ height: '32px' }}/>;
        }
    }

    determineStatus(isLabelPrinted, status) {
        if (isLabelPrinted && status !== STATUS.COMPLETE) {
            return (
                <Tag color="orange" style={{ fontSize: '11px', fontWeight: 'bold' }}>
                    LABEL PRINTED
                </Tag>
            );
        } else {
            let statusText = status === "HOLD" ? "ON HOLD" 
                : status === STATUS.FULFILLED ? "WAITING FOR PICK-UP" 
                : status === "HOLD_WEIGHT" ? "HOLD (Weight needed)" 
                : status;

            let tagColor = 'default';
            switch (status) {
                case STATUS.COMPLETE:
                case STATUS.FULFILLED:
                    tagColor = 'green';
                    break;
                case STATUS.HOLD:
                case 'HOLD_WEIGHT':
                    tagColor = 'red';
                    break;
                case STATUS.REJECTED:
                    tagColor = 'volcano';
                    break;
                default:
                    tagColor = 'geekblue';
            }

            return (
                <Tag color={tagColor} style={{ fontSize: '11px', fontWeight: 'bold' }}>
                    {statusText}
                </Tag>
            );
        }
    }

    determinePrintType(shipmentId, isLabelPrinted, status, localLabelUrl, isSearched) {
        let labelExists = !!isLabelPrinted || status === STATUS.COMPLETE;
        let downloadHandler = labelExists ?
            (async (e) => {
                await this.handleLabelDownload(shipmentId);
                e.stopPropagation();
            }) :
            ((e) => {
                this.props.getPickslips(shipmentId);
                e.stopPropagation();
            });

        if (isSearched && localLabelUrl) {
            return (
                <div style={{ display: 'flex', gap: '4px', flexDirection: 'column' }}>
                    <Button 
                        type="primary"
                        onClick={downloadHandler}
                    >
                        {labelExists ? 'PRINT LABEL' : 'PRINT PICKSLIP'}
                    </Button>
                    <Button 
                        type="primary"
                        onClick={(e) => {
                            window.open(localLabelUrl, '_blank');
                            e.stopPropagation();
                        }}
                        style={{ 
                            backgroundColor: '#52c41a',
                            borderColor: '#52c41a'
                        }}
                    >
                        PRINT LABEL
                    </Button>
                </div>
            );
        }

        return (
            <Button
                type="primary"
                onClick={downloadHandler}
            >
                <RiPrinterLine size={16} style={{ marginRight: '4px' }} />
                {labelExists ? 'Print Label' : 'Print Pickslip'}
            </Button>
        );
    }

    calculateTimeSinceOrder(orderedAt) {
        if (!orderedAt) return null;

        const now = Math.floor(Date.now() / 1000); // Current time in seconds
        const orderTime = orderedAt; // Already in seconds (Unix timestamp)
        const diffSeconds = now - orderTime;
        const diffHours = diffSeconds / 3600;
        const diffDays = diffHours / 24;

        let text, color;

        if (diffHours < 24) {
            const hours = Math.floor(diffHours);
            text = `< ${hours === 0 ? 1 : hours + 1}h`;
            color = 'green';
        } else if (diffDays < 2) {
            text = '< 1 day';
            color = 'blue';
        } else if (diffDays < 3) {
            text = '< 2 days';
            color = 'orange';
        } else if (diffDays < 4) {
            text = '< 3 days';
            color = 'volcano';
        } else {
            const days = Math.floor(diffDays);
            text = `${days}d overdue`;
            color = 'red';
        }

        return (
            <Tag color={color} style={{ fontSize: '11px', fontWeight: 'bold' }}>
                {text}
            </Tag>
        );
    }

    buildShipmentInformation(shipment) {
        return {
            storeLogo: this.renderStoreLogo(shipment.brand),
            carrierLogo: this.renderCarrierLogo(shipment),
            carrierTitle: this.determineCarrierTitle(shipment),
            status: this.determineStatus(shipment.labelsPrinted, shipment.status),
            print: this.determinePrintType(shipment.shipmentId, shipment.labelsPrinted, shipment.status, shipment.localLabelUrl, shipment.isSearched),
            timeSince: this.calculateTimeSinceOrder(shipment.orderedAt),
        };
    }

    getShipmentAlert = (shipmentId) => {
        return this.state.shipmentAlerts.find(x => x.id === shipmentId)?.alert;
    };

    handleGenerateManifest = () => {
        if (!this.state.manifestLoading) {
            this.setState({ manifestLoading: true });
            this.props.getManifest();
        }
    };

    handlePickslipGeneration = (type, web_store = null) => {
        const store = this.props.user.store;
        this.props.getAllPickslips(store, type, web_store);
    };

    handleSearchChange = (e) => {
        this.setState({ searchText: e.target.value });
    };

    handleTabChange = (activeKey) => {
        // Update URL hash
        if (activeKey === 'open') {
            window.history.pushState(null, null, window.location.pathname);
        } else {
            window.history.pushState(null, null, `${window.location.pathname}#${activeKey}`);
        }

        this.setState({ 
            activeTab: activeKey,
            searchText: '' // Clear search when switching tabs
        });
        this.loadDataForTab(activeKey);
    };

    handleExpand = (expanded, record) => {
        if (expanded) {
            // Accordion behavior - close others when opening one
            this.setState({ 
                expandedRowKeys: [record.shipmentId] 
            });
            this.props.getFocusedShipment(record.shipmentId);
        } else {
            this.setState({ 
                expandedRowKeys: [] 
            });
            this.props.getFocusedShipment(null);
        }
    };

    getRowClassName = (record) => {
        let classes = [];

        if (this.isDisabled(record.status)) {
            classes.push('shipping-row-complete');
        }

        if (record.labelsPrinted && record.status !== STATUS.COMPLETE) {
            classes.push('shipping-row-urgent');
        }

        let alert = this.getShipmentAlert(record.shipmentId);
        if (alert) {
            classes.push(`shipping-row-${alert}`);
        }

        return classes.join(' ');
    };

    renderExpandedRow = (record) => {
        // Use different components based on active tab
        if (this.state.activeTab === 'fulfilled') {
            return <FulfilledShipmentDetails shipment={record} />;
        }

        return (
            <div style={{ padding: '16px' }}>
                <ShippingDropDownComponentPrototype 
                    disabled={this.isDisabled(record.status)} 
                    shipment={record}
                />
            </div>
        );
    };

    render() {
        // Use fulfilledShipments for fulfilled tab, manifests for manifests tab, regular shipments for open tab
        const shipmentData = this.state.activeTab === 'fulfilled' ? 
            this.props.fulfilledShipments : 
            this.state.activeTab === 'manifests' ?
            this.props.manifests :
            this.props.shipments;

        const filteredShipments = shipmentData
            .filter(shipment => {
                // First apply tab-specific filtering
                let tabFiltered = false;
                if (this.state.activeTab === 'fulfilled') {
                    tabFiltered = true; // Show all searched/fulfilled shipments
                } else if (this.state.activeTab === 'manifests') {
                    tabFiltered = true; // Show all manifests (currently empty)
                } else {
                    // For open tab, filter out completed shipments except click & collect
                    tabFiltered = !(shipment.status === STATUS.COMPLETE && shipment.method !== METHODS.CLICKCOLLECT);
                }

                if (!tabFiltered) return false;

                // Then apply search filtering if there's search text
                if (this.state.searchText.trim() === '') {
                    return true;
                }

                const searchText = this.state.searchText.toLowerCase().trim();

                const searchableFields = [
                    shipment.shipmentId,
                    shipment.customerName
                ].filter(field => field != null);

                return searchableFields.some(field => 
                    String(field).toLowerCase().includes(searchText)
                );
            });

        // Define columns based on active tab
        const manifestColumns = [
            {
                title: 'Date',
                dataIndex: 'date',
                key: 'date',
                width: '20%'
            },
            {
                title: 'Manifest ID',
                dataIndex: 'manifestId',
                key: 'manifestId',
                width: '25%'
            },
            {
                title: 'Store',
                dataIndex: 'store',
                key: 'store',
                width: '15%'
            },
            {
                title: 'Shipments',
                dataIndex: 'shipmentCount',
                key: 'shipmentCount',
                width: '15%'
            },
            {
                title: 'Status',
                dataIndex: 'status',
                key: 'status',
                width: '15%'
            },
            {
                title: 'Actions',
                dataIndex: 'actions',
                key: 'actions',
                width: '10%'
            }
        ];

        const shipmentColumns = [
            {
                title: 'Carrier',
                dataIndex: 'carrier',
                key: 'carrier',
                width: '10%',
                render: (text, record) => {
                    const shipmentInfo = this.buildShipmentInformation(record);
                    const urgencyClass = this.determineCarrierUrgency(record.carrier, record.method);

                    let backgroundColor = 'transparent';
                    if (urgencyClass === 'urgent') {
                        backgroundColor = '#D71635'; // Red for urgent
                    } else if (record.carrier === 'AUSPOST' && record.method !== METHODS.EXPRESS) {
                        backgroundColor = 'rgb(215, 141, 22)'; // Orange for Auspost Standard
                    }

                    return (
                        <div style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            color: 'white',
                            padding: '16px',
                            fill: 'white',
                            backgroundColor: backgroundColor,
                            height: '100%',
                        }}>
                            <div style={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                width: '32px',
                                height: '32px',
                            }}>
                                {shipmentInfo.carrierLogo}
                            </div>
                        </div>
                    );
                }
            },
            {
                title: 'Store',
                dataIndex: 'brand',
                key: 'brand',
                width: '12%',
                render: (text, record) => {
                    const shipmentInfo = this.buildShipmentInformation(record);

                    let backgroundColor = 'transparent';
                    if (record.brand === 'US') {
                        backgroundColor = '#000';
                    } else if (record.brand === 'PS') {
                        backgroundColor = '#F2EFE6';
                    }

                    return (
                        <div style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            height: '100%',
                            backgroundColor: backgroundColor,
                            padding: '16px'
                        }}>
                            {shipmentInfo.storeLogo}
                        </div>
                    );
                }
            },
            {
                title: 'Shipment Details',
                dataIndex: 'shipmentId',
                key: 'shipmentDetails',
                width: '25%',
                render: (text, record) => {
                    const shipmentInfo = this.buildShipmentInformation(record);
                    const isUrgent = record.method === METHODS.CLICKCOLLECT || record.method === METHODS.SAME_DAY;
                    const shortShipmentId = text.substring(0, 13);

                    return (
                        <div>
                            <div
                                style={{
                                    fontWeight: '700',
                                    fontSize: '16px',
                                    color: isUrgent ? '#ff4d4f' : 'inherit'
                                }}
                            >
                                {shipmentInfo.carrierTitle}
                            </div>
                            <div style={{
                                fontWeight: '700',
                                fontSize: '14px',
                                textTransform: 'uppercase',
                                color: '#666',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '4px'
                            }}>
                                <span style={{ userSelect: 'none' }}>SHIPMENT: </span>
                                <span style={{ userSelect: 'text' }}>{shortShipmentId}</span>
                                <Button
                                    type="text"
                                    size="small"
                                    style={{
                                        minWidth: 'auto',
                                        padding: '2px',
                                        height: '18px',
                                        width: '18px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}
                                    onClick={(e) => {
                                        navigator.clipboard.writeText(shortShipmentId);
                                        e.stopPropagation();
                                    }}
                                    title="Copy shipment ID"
                                >
                                    <RiFileCopyLine size={12} />
                                </Button>
                            </div>
                        </div>
                    );
                }
            },
            {
                title: 'Time Since Order',
                dataIndex: 'timeSince',
                key: 'timeSince',
                width: '15%',
                render: (text, record) => {
                    const shipmentInfo = this.buildShipmentInformation(record);
                    return shipmentInfo.timeSince;
                }
            },
            {
                title: 'Status',
                dataIndex: 'status',
                key: 'status',
                width: '20%',
                render: (text, record) => {
                    const shipmentInfo = this.buildShipmentInformation(record);
                    return shipmentInfo.status;
                }
            },
            {
                title: 'Print',
                dataIndex: 'print',
                key: 'print',
                width: '15%',
                render: (text, record) => {
                    const shipmentInfo = this.buildShipmentInformation(record);
                    return shipmentInfo.print;
                }
            }
        ];

        // Choose columns based on active tab
        const columns = this.state.activeTab === 'manifests' ? manifestColumns : shipmentColumns;


        // Determine empty message for table
        const emptyMessage = this.state.activeTab === 'manifests' ? 
            'No manifests to display' :
            this.state.activeTab === 'fulfilled' ? 
            'No fulfilled shipments found' :
            this.state.searchText.trim() !== '' ? 
            'No shipments match your search' :
            'No pending shipments to fulfill';

        return (
            <Layout style={{ minHeight: '100vh', background: '#f0f2f5' }} className="shipping-new">
                <Header style={{
                    background: '#fff',
                    padding: '0 24px',
                    height: 'auto',
                    lineHeight: 'normal',
                    position: 'sticky',
                    boxShadow: 'rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.14) 0px 1px 2px',
                    top: 0,
                    zIndex: 1000
                }}>
                    <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        padding: '16px 0'
                    }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '24px' }}>
                            <Title level={2} style={{
                                margin: 0,
                                fontWeight: 700,
                                textTransform: 'uppercase',
                                color: '#262626'
                            }}>
                                Your Shipments
                            </Title>

                            <Tabs
                                activeKey={this.state.activeTab}
                                onChange={this.handleTabChange}
                                size="large"
                                style={{ marginBottom: 0 }}
                            >
                                <TabPane tab="Open" key="open" />
                                <TabPane tab="Fulfilled" key="fulfilled" />
                                <TabPane tab="Manifests" key="manifests" />
                            </Tabs>
                        </div>

                        <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                            {this.state.activeTab !== 'manifests' && (
                                <Input
                                    placeholder="Search shipments..."
                                    prefix={<RiSearchLine size={16} color="rgba(0,0,0,.25)" />}
                                    value={this.state.searchText}
                                    onChange={this.handleSearchChange}
                                    allowClear
                                    style={{ width: 200 }}
                                />
                            )}

                            {this.state.activeTab === 'open' && (
                                <Button
                                    type="primary"
                                    onClick={() => this.props.getShipments()}
                                >
                                    Refresh
                                </Button>
                            )}

                            {this.state.activeTab === 'open' && (
                                <>
                                    <Dropdown 
                                        overlay={
                                            <Menu>
                                                <Menu.Item key="all" onClick={() => this.handlePickslipGeneration('ALL')}>
                                                    All Pick Slips
                                                </Menu.Item>
                                                <Menu.Item key="clickcollect" onClick={() => this.handlePickslipGeneration(METHOD.CLICKCOLLECT)}>
                                                    Print Click & Collect
                                                </Menu.Item>
                                                <Menu.Item key="us-all" onClick={() => this.handlePickslipGeneration('ALL', 'US')}>
                                                    US All Pick Slips
                                                </Menu.Item>
                                                <Menu.Item key="ps-all" onClick={() => this.handlePickslipGeneration('ALL', 'PS')}>
                                                    PS All Pick Slips
                                                </Menu.Item>
                                            </Menu>
                                        }
                                        trigger={['click']}
                                    >
                                        <Button>
                                            Print Pick Slips
                                            <RiArrowDownSLine size={16} style={{ marginLeft: '4px' }} />
                                        </Button>
                                    </Dropdown>

                                    <Button
                                        onClick={this.handleGenerateManifest}
                                        disabled={this.props.manifest === 'disabled' || this.state.manifestLoading}
                                        loading={this.state.manifestLoading}
                                    >
                                        Generate Manifest
                                    </Button>
                                </>
                            )}
                        </div>
                    </div>
                </Header>

                <Content style={{ padding: '24px', paddingTop: '12px', background: '#f0f2f5' }}>
                    <div className="shipping-new-last-updated" style={{
                        textAlign: 'right',
                        fontStyle: 'italic',
                        color: '#666',
                        fontSize: '12px',
                        marginBottom: '16px'
                    }}>
                        Last updated: {new Date().toLocaleString('en-AU', { 
                            year: 'numeric',
                            month: '2-digit',
                            day: '2-digit',
                            hour: '2-digit',
                            minute: '2-digit',
                            hour12: true
                        })}
                    </div>

                    <div style={{
                        background: '#fff',
                        padding: '0',
                        boxShadow: '0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)'
                    }}>
                        {this.state.activeTab === 'open' && (
                            this.props.isLoadingOpen ? (
                                <div style={{ display: 'flex', justifyContent: 'center', padding: '50px' }}>
                                    <Spin size="large" />
                                </div>
                            ) : (
                                <OpenShipmentsTable
                                    shipments={filteredShipments}
                                    expandedRowKeys={this.state.expandedRowKeys}
                                    onExpand={this.handleExpand}
                                    renderExpandedRow={this.renderExpandedRow}
                                    emptyMessage={emptyMessage}
                                />
                            )
                        )}

                        {this.state.activeTab === 'fulfilled' && (
                            this.props.isLoadingFulfilled ? (
                                <div style={{ display: 'flex', justifyContent: 'center', padding: '50px' }}>
                                    <Spin size="large" />
                                </div>
                            ) : (
                                <FulfilledShipmentsTable
                                    shipments={filteredShipments}
                                    expandedRowKeys={this.state.expandedRowKeys}
                                    onExpand={this.handleExpand}
                                    emptyMessage={emptyMessage}
                                />
                            )
                        )}

                        {this.state.activeTab === 'manifests' && (
                            this.props.isLoadingManifests ? (
                                <div style={{ display: 'flex', justifyContent: 'center', padding: '50px' }}>
                                    <Spin size="large" />
                                </div>
                            ) : (
                                <ManifestsTable
                                    manifests={filteredShipments}
                                    emptyMessage={emptyMessage}
                                />
                            )
                        )}
                    </div>
                </Content>
            </Layout>
        );
    }
}

const ShippingTablePrototypeConnected = connect(mapStateToProps, mapDispatchToProps)(ShippingTablePrototype);
export default ShippingTablePrototypeConnected;